module.exports = __webpack_public_path__ + "static/img/tabela.cb1f110.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/limao-zero/tabela.png
// module id = UFRg
// module chunks = 0